import React, {Component} from 'react'
import Logo from "../logo"
import './header.css'

class Header extends Component {


    render() {
        return (
            <div className="Header">
                <div className="Header__logo">
                    <Logo/>
                </div>
            </div>
        );
    }
}


export default Header;


// WEBPACK FOOTER //
// ./src/components/header/index.js